/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createSubset } from '../../factoriesNumber.js';
export var subsetDependencies = {
  createSubset
};